const waitFor = (test, successCallback, failureCallback = () => {
}, count = 0, maxCount = 20, msBetweenRetries = 100) => {
  const callMyself = (updatedCount) => () => {
    waitFor(
      test,
      successCallback,
      failureCallback,
      updatedCount,
      maxCount,
      msBetweenRetries
    );
  };
  if (test()) {
    successCallback();
  } else if (count < maxCount) {
    setTimeout(callMyself(count + 1), msBetweenRetries);
  } else {
    failureCallback();
  }
};
export {
  waitFor as w
};
